import { a as l } from "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./es.object.keys-9d66766f.js";
import { useState as g, useEffect as c } from "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { i as n } from "./isApiSupported-66660265.js";
import { i as s } from "./isClient-2f5bedbd.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
var m = /* @__PURE__ */ function() {
  function i() {
    this.storageData = {};
  }
  var r = i.prototype;
  return r.key = function(t) {
    var o = Object.keys(this.storageData);
    return t >= 0 && t < o.length ? o[t] : null;
  }, r.getItem = function(t) {
    return this.storageData[t] || null;
  }, r.setItem = function(t, o) {
    this.storageData[t] = JSON.stringify(o);
  }, r.removeItem = function(t) {
    delete this.storageData[t];
  }, r.clear = function() {
    this.storageData = {};
  }, l(i, [{
    key: "length",
    get: function() {
      return Object.keys(this.storageData).length;
    }
  }]);
}(), f = function(r, e, t) {
  var o = t.getItem(r);
  return o !== null ? JSON.parse(o) : e;
}, u = function(r, e, t) {
  var o = g(function() {
    return f(r, e, t);
  }), a = o[0], p = o[1];
  return c(function() {
    if (a === void 0)
      return t.removeItem(r);
    t.setItem(r, JSON.stringify(a));
  }, [r, a, t]), [a, p];
}, T = function(r, e) {
  var t;
  return u(r, e, s && n("localStorage") ? (t = window) == null ? void 0 : t.localStorage : new m());
}, U = function(r, e) {
  var t;
  return u(r, e, s && n("sessionStorage") ? (t = window) == null ? void 0 : t.sessionStorage : new m());
};
export {
  T as useLocalStorage,
  U as useSessionStorage,
  u as useStorage
};
